import pako from 'pako/lib/inflate.js';
export { pako as default };